module.exports = __webpack_public_path__ + "static/media/map-image2-cropped.8655382f.png";